import { render, staticRenderFns } from "./StockViewReceipt.vue?vue&type=template&id=5735a35d&scoped=true"
import script from "./StockViewReceipt.vue?vue&type=script&lang=js"
export * from "./StockViewReceipt.vue?vue&type=script&lang=js"
import style0 from "./StockViewReceipt.vue?vue&type=style&index=0&id=5735a35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735a35d",
  null
  
)

export default component.exports